import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/**
 * The old methodology page, removed in T-0219 when assessment defaults
 * replaced the gate (T-0224, T-0242): kept as a redirect so a bookmark lands
 * on the Health & Readiness Overview.
 */
export const Route = createFileRoute('/engagements/$engagementId/methodology')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'overview' });
  },
});
